import { useEffect } from 'react'

// Google Analytics 4 Measurement ID - altere aqui para ativar/desativar
// Para desativar: coloque "" (string vazia) ou null
// Para ativar: coloque seu Measurement ID (ex: "G-XXXXXXXXXX")
const GA_MEASUREMENT_ID = '' // ← Coloque seu ID aqui

const GoogleAnalyticsScript = () => {
  useEffect(() => {
    // Só carrega em produção e se GA_MEASUREMENT_ID estiver configurado
    const isProduction = import.meta.env.PROD

    if (!isProduction || !GA_MEASUREMENT_ID) {
      if (!isProduction) {
        console.log(
          '[Google Analytics] Não carregado - ambiente de desenvolvimento',
        )
      }
      return
    }

    // Verifica se já foi carregado para evitar duplicação
    if ((window as any).gtag) {
      return
    }

    // Inicializa o dataLayer
    ;(window as any).dataLayer = (window as any).dataLayer || []
    function gtag(...args: any[]) {
      ;(window as any).dataLayer.push(arguments)
    }
    ;(window as any).gtag = gtag

    gtag('js', new Date())
    gtag('config', GA_MEASUREMENT_ID, {
      page_path: window.location.pathname,
    })

    // Carrega o script do GA4 de forma assíncrona
    const script = document.createElement('script')
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    script.async = true
    script.id = 'ga4-script'

    document.head.appendChild(script)

    return () => {
      // Cleanup: remove o script se o componente for desmontado
      const existingScript = document.getElementById('ga4-script')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])

  return null
}

export default GoogleAnalyticsScript
